var render = function render(){var _vm=this,_c=_vm._self._c;return _c('product-form',{ref:"form",attrs:{"distributorId":_vm.distributorId,"show-cogs":false,"data-cy":_vm.supplierCy.PRODUCTS.NEW_PRODUCT.PRODUCT_INFO},on:{"submitSuccess":_vm.onSubmitSuccess,"formValid":_vm.isValid}})
}
var staticRenderFns = []

export { render, staticRenderFns }